var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_2594)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43045 2.02515C7.61453 2.44697 7.4218 2.93815 6.99998 3.12222C5.87714 3.61221 4.89142 4.3698 4.12901 5.32875C3.3666 6.28769 2.8507 7.41881 2.62643 8.6232C2.40215 9.82759 2.47632 11.0686 2.84245 12.2377C3.20859 13.4068 3.85554 14.4684 4.72674 15.3297C5.59795 16.191 6.66688 16.8258 7.84009 17.1786C9.01329 17.5313 10.2551 17.5913 11.4568 17.3533C12.6586 17.1153 13.7837 16.5865 14.7339 15.8132C15.6841 15.0399 16.4303 14.0456 16.9075 12.9172C17.0867 12.4933 17.5757 12.295 17.9996 12.4742C18.4235 12.6535 18.6218 13.1424 18.4425 13.5663C17.8594 14.9454 16.9473 16.1607 15.7859 17.1059C14.6246 18.051 13.2494 18.6973 11.7806 18.9882C10.3118 19.2791 8.7941 19.2058 7.36018 18.7747C5.92626 18.3435 4.61978 17.5677 3.55498 16.5149C2.49017 15.4622 1.69946 14.1647 1.25196 12.7358C0.804462 11.3069 0.713809 9.79012 0.987925 8.31808C1.26204 6.84605 1.89258 5.46358 2.82442 4.29153C3.75626 3.11948 4.96102 2.19354 6.33338 1.59467C6.7552 1.41059 7.24638 1.60332 7.43045 2.02515Z",
    fill: "#82858D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41083 1.07757C9.56711 0.921293 9.77907 0.833496 10.0001 0.833496C11.2039 0.833496 12.3959 1.0706 13.508 1.53127C14.6202 1.99194 15.6307 2.66715 16.4819 3.51835C17.3331 4.36955 18.0083 5.38008 18.469 6.49223C18.9296 7.60438 19.1667 8.79638 19.1667 10.0002C19.1667 10.4604 18.7937 10.8335 18.3334 10.8335H10.0001C9.53984 10.8335 9.16675 10.4604 9.16675 10.0002V1.66683C9.16675 1.44582 9.25455 1.23385 9.41083 1.07757ZM10.8334 2.5466V9.16683H17.4536C17.3755 8.46801 17.1993 7.78224 16.9292 7.13004C16.5523 6.2201 15.9998 5.3933 15.3034 4.69686C14.6069 4.00042 13.7801 3.44798 12.8702 3.07107C12.218 2.80091 11.5322 2.62473 10.8334 2.5466Z",
    fill: "#82858D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_2594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.efd72aaff72fe57267c92cc92dd2f5ac.svg";
export { ForwardRef as ReactComponent };